import { create } from 'zustand';

interface BookmarkStore {
  myBookmarks: any[];
  bookmarksSharedWithme: any[];
  selectedBookmark: any;

  setMyBookmarks: (bookmarks: any[]) => void;
  setBookmarksSharedWithme: (bookmarks: any) => void;
  setSelectedBookmark: (bookmark: any) => void;
}

export const useBookmarkStore = create<BookmarkStore>((set) => ({
  myBookmarks: [],
  bookmarksSharedWithme: [],
  selectedBookmark: null,

  setMyBookmarks: (bookmarks: any[]) => set({ myBookmarks: bookmarks }),
  setBookmarksSharedWithme: (bookmarks: any) => set({ bookmarksSharedWithme: bookmarks }),
  setSelectedBookmark: (bookmark: any) => set({ selectedBookmark: bookmark }),
}));
